import { HTML_LINK_TARGET } from '../../../constants/html'
import {
  useIsExternalContactProfileNGAvailable,
  useIsProviderProfileNGAvailable,
  useIsUserProfileNGAvailable,
} from '../../../hooks'
import { stopPropagation } from '../../../utils/events'
import { UserListItem } from '../../ListItem'
import { MultiValuedListMoreItem } from '../../MultiValuedList'
import { getUserLinkProps } from '../User.utils'

import * as styles from './UserMultiValueListMoreItemLinked.module.css'

function UserMultiValueListMoreItemLinked({
  className = styles.UserMultiValueListMoreItemLinked,
  link,
  ref,
  target = HTML_LINK_TARGET.blank,
  user,
  ...restProps
}) {
  const isExternalContactProfileNGAvailable =
    useIsExternalContactProfileNGAvailable()
  const isProviderProfileNGAvailable = useIsProviderProfileNGAvailable()
  const isUserProfileNGAvailable = useIsUserProfileNGAvailable()

  const { LinkComponent, userLink } = getUserLinkProps({
    isExternalContactProfileNGAvailable,
    isProviderProfileNGAvailable,
    isUserProfileNGAvailable,
    link,
    user,
  })

  return (
    <MultiValuedListMoreItem
      {...restProps}
      {...userLink}
      Component={LinkComponent}
      className={className}
      ref={ref}
      rel='noreferrer'
      target={target}
      onClick={stopPropagation}
    >
      <UserListItem
        {...restProps}
        Avatar={null}
        isArchived={user.archived}
        value={user}
      />
    </MultiValuedListMoreItem>
  )
}

export default UserMultiValueListMoreItemLinked
